import React from "react"
import { clearActiveMenuItem, setActiveMenuItem, setupMenu, updateMenuRoot } from "../../../actions/menu";
import M from "../../../strings";
import EntitiesGridControl from "../../components/entitiesGridControl";
import { Layout, Screen, SideBar } from "../../components/layout"
import { getSurveyTemplateMenu, MENU_ITEM_TYPES } from "../../../model/menu";
import { HeaderBlockWithBreadcrumbs } from "../../components/common";
import { Query } from "../../../framework/query";
import { getLoggedUser } from "../../../api/session";
import { loadAllowedStores } from "../../../actions/stores";
import { StoresStore } from "../../../stores/stores";
import { secureScreen } from "../../components/secure";



class _SurveyTemplateStoresForm extends Screen {
    componentDidMount() {
        const id = this.props.entityId;

        if (id) {
            updateMenuRoot({
                root: getSurveyTemplateMenu(id)
            });
            setActiveMenuItem({id: "surveyTemplate.stores"});
        }
        StoresStore.subscribe(this, state => {
            this.setState({
                ids: state.allowedStores
            }) 
        });

        const surveyTemplateId = this.props.entityId;
        if (surveyTemplateId) {
            loadAllowedStores({surveyTemplateId})
        }
    }

    componentWillUnmount() {

        clearActiveMenuItem();
        setupMenu({user: getLoggedUser()});
    }

    getTitle() {
        return M("allowedStores")
    }

    render() {
        return (
            <Layout>
                <SideBar/>
                <HeaderBlockWithBreadcrumbs title={this.getTitle()}/>
                {this.state?.ids && <EntitiesGridControl ref={"grid"} initialQuery={() => new Query().in("id", this.state?.ids).hideFilter("id")} entity={"store"} />}
            </Layout>
        )
    }
}

export const SurveyTemplateStoresForm = secureScreen(_SurveyTemplateStoresForm)